import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

class ContactHeader extends React.Component {
  render() {
    return (
      <div>
        <OwlCarousel
          items={1}
          loop
          animateIn="fadeIn"
          animateOut="fadeOut"
          autoplay
        >
          <div className="item">
            <div className="contact  d-flex align-items-center">
              <div className="container">
                <div className="columns">
                  <div className="column is-8 has-text-white">
                    <div className="large-text">
                      The New Era of Business and Technology
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="item">
            <div className="contact d-flex align-items-center contact-easy">
              <div className="container">
                <div className="columns">
                  <div className="column is-8 has-text-white">
                    <div className="large-text">Shopping Made Easy!</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </OwlCarousel>
      </div>
    );
  }
}

export default ContactHeader;
